import { Phone } from "lucide-react";

import { Button } from "@/components/ui/button";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";
import { BOOKING_PHONE, BOOKING_PHONE_TEL, MIN_LEAD_HOURS } from "@/lib/lead-time";

const COPY = {
  nl: {
    title: "Bel ons om te boeken",
    body: `Uw ophaaltijd ligt binnen ${MIN_LEAD_HOURS} uur, daarom kunnen wij deze rit niet online reserveren. Bel ons even op ${BOOKING_PHONE}, dan kijken we samen naar de mogelijkheden.`,
    call: `Bel ${BOOKING_PHONE}`,
    close: "Andere tijd kiezen",
  },
  en: {
    title: "Please call us to book",
    body: `Your pick-up time is within ${MIN_LEAD_HOURS} hours, so we cannot take this ride online. Call us on ${BOOKING_PHONE} and we will look at the options with you.`,
    call: `Call ${BOOKING_PHONE}`,
    close: "Choose another time",
  },
} as const;

/** Popup die direct verschijnt zodra het gekozen ophaalmoment binnen 3 uur ligt. */
export function LeadTimeDialog({
  open,
  onOpenChange,
  locale = "nl",
}: {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  locale?: "nl" | "en";
}) {
  const t = COPY[locale];
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="sm:max-w-md">
        <DialogHeader>
          <DialogTitle className="flex items-center gap-2 font-display">
            <Phone className="size-5 text-primary" /> {t.title}
          </DialogTitle>
          <DialogDescription className="text-base leading-relaxed text-foreground">
            {t.body}
          </DialogDescription>
        </DialogHeader>
        <DialogFooter className="gap-2 sm:justify-start">
          <Button asChild size="lg" className="amber-surface font-semibold">
            <a href={`tel:${BOOKING_PHONE_TEL}`}>{t.call}</a>
          </Button>
          <Button variant="outline" size="lg" onClick={() => onOpenChange(false)}>
            {t.close}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
